import styled from 'styled-components';

export const TableWrapper = styled.div`
	width: 100%;
	overflow: hidden;
`;

export const CustomTable = styled.table`
	width: 100%;
	border-collapse: collapse;
	border-spacing: 0;
	overflow: hidden;
	border-radius: 8px;

	thead {
		background-color: ${({ theme }) => theme.palette.secondary[100]};

		th {
			font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
			font-weight: ${({ theme }) => theme.sizes.weights.semibold} !important;
		}
	}

	tbody {
		background-color: ${({ theme }) => theme.palette.secondary[50]};

		td {
			font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
		}
	}

	th,
	td {
		padding: 10px 20px;
		font-weight: ${({ theme }) => theme.sizes.weights.regular};

		span {
			font-weight: ${({ theme }) => theme.sizes.weights.semibold};
		}
	}
`;

export const StatusTaskBadge = styled.div<{ isFinished: boolean }>`
	background-color: ${({ isFinished, theme }) => (isFinished ? '#E8F7EC' : theme.palette.secondary[100])};
	border-radius: 4px;
	color: '#222';
	line-height: 36px;
	height: 36px;
	margin: 0 auto;
	width: 120px;
`;
